module.exports = __webpack_public_path__ + "assets/img/2.cb39fe78.jpg";